exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@supports (padding-top: env(safe-area-inset-top)) {\n  .safeHeader_1d8vJjd5 {\n    padding-top: env(safe-area-inset-top);\n  }\n}", ""]);

// exports
exports.locals = {
	"safeHeader": "safeHeader_1d8vJjd5"
};